<div class="fc-article-host">
    <div class="fc-article-header">&nbsp;</div>
    <h1 [innerHtml]="page.heading"></h1>
    <div class="fc-article-summary" [innerHtml]="page.summary | markedInline"></div>
    <fc-publish-profile [profile]="page.publishDetails"></fc-publish-profile>
    <fc-disclaimer *ngIf="disclosure" [message]="disclosure" [showLink]="showGenericLink"></fc-disclaimer>
</div>
<fc-content-container [page]="page" [analyticsMode]="'Article'" ></fc-content-container>